<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
      <div class="searchListWrap">
        <div class="searchList">
          <div class="center_text">
          <h5 class="period">조회기간</h5>
            <div class="inBtnWrap">
              <h5 class="period date" v-if="IsWhole">전체조회기간입니다.</h5>
              <h5 class="period date" v-else>{{dateStart}}<b>-</b>{{dateEnd}}</h5>
              <div class="inBtn pre red">
                <router-link to="./certificateLookupDate">
                  <button type="button" class="search function">조회하기</button>
                </router-link>
              </div>
            </div>
          </div>
          <div class="card_wrap">
            <div class="card_list" v-for="c in getCertificateLookupList" :key="c.certificateIssuanceId" @click.prevent="goDetail(c.certificateIssuanceId)">
              <div class="cl_title">
                <h2 :class="{white : c.state === 0}">{{c.state | setState}}</h2>
                <div class="cl_btn large">
                  <button type="button" class="red">자세히보기</button>
                </div>
              </div>
              <div class="cl_content black">
                <div class="content_item one">
                  <div class="ci_title">
                    <label>신청일</label>
                  </div>
                  <div class="ci_content">
                    <p>{{c.requestDate}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="listEmpty" v-if="!firstDataSet">
          <div class="imgWrap">
            <img src="@/assets/images/error.svg">
          </div>
          <div class="ct_content">
            <p>신청 내역이 없습니다.</p>
          </div>
          </div>
            </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import EventBus from '@/utils/bus'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '제증명 발급 신청 내역',
        prevUrl: '/'
      },
      dataFlag: false,
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      monthDate: '',
      today: '',
      firstDataSet: false,
      wrongWay: true,
      setCount: false
    }
  },
  computed: {
    ...mapGetters('certificate', [
      'getCertificateLookupList',
      'getCertificateLookupDate'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('certificate', [
      'SET_CERTIFICATE_DATE'
    ]),
    ...mapActions('certificate', [
      'CERTIFICATE_LOOKUP',
      'CERTIFICATE_LOOKUP_DETAIL'
    ]),
    async goDetail (code) {
      console.log('code: ', code)
      try {
        await this.CERTIFICATE_LOOKUP_DETAIL(code)
          .then(() => {
            this.$router.push(`./certificateLookupDetail/${code}`)
          })
      } catch (error) {
        console.log('error :', error);
        console.log('제증명 발급 신청 내역 - 상세로 이동하는 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    // 오늘 -7일전 ~ 오늘 날짜 조회
    getDefaultDate () {
      let date = new Date()
      let monthDate = date.getTime() - (7 * 24 * 60 * 60 * 1000)
      // const year = date.getFullYear()
      // const month = date.getMonth() + 1
      // let dateMutated = new Date(year, month, 0)

      date = this.$moment(date).format('YYYY-MM-DD')
      monthDate = this.$moment(monthDate).format('YYYY-MM-DD')
      // dateMutated = this.$moment(dateMutated).format('YYYY-MM-DD')

      this.monthDate = monthDate
      this.today = date
    },
    // 예약조회를 실행함
    async fetchData () {
      try {
        let requestData
        if (this.dataFlag === false) {
          requestData = {
            startDate: null,
            endDate: null,
            default: true
          }
        } else {
          requestData = {
            startDate: this.dateStart,
            endDate: this.dateEnd,
            default: this.IsWhole
          }
        }
        await this.CERTIFICATE_LOOKUP(requestData)
          .then(() => this.carryData())
      } catch (error) {
        this.SET_POPUP(true)
        this.popupSet.content = errorParser.parse(error)
      }
    },
    carryData () {
      if (this.getCertificateLookupList.length >= 1) {
        this.firstDataSet = true
      } else {
        this.firstDataSet = false
      }
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    console.log('this.getCertificateLookupList', this.getCertificateLookupList)
    console.log('this.getCertificateLookupList.length', this.getCertificateLookupList.length >= 1)
    if (this.getCertificateLookupDate.length >= 1) {
      this.dataFlag = true
      this.dateStart = this.getCertificateLookupDate[0]
      this.dateEnd = this.getCertificateLookupDate[1]
      this.IsWhole = this.getCertificateLookupDate[2]
    } else {
      this.IsWhole = true
      this.dataFlag = false
    }
    this.getDefaultDate()
    this.fetchData()
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    if (this.getCertificateLookupDate.length >= 1) {
      this.SET_CERTIFICATE_DATE('')
      this.dataFlag = false
    }
    this.setCount = false
    EventBus.$off('pageAccess')
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  filters: {
    setState (val) {
      if (val === 0) {
        return String(val).replace('0', '신청')
      } else if (val === 1) {
        return String(val).replace('1', '발급완료')
      } else if (val === 2) {
        return String(val).replace('2', '수령완료')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
